import { render, staticRenderFns } from "./historique-imagerie-medicale.html?vue&type=template&id=231c866a&scoped=true&external"
import script from "./historique-imagerie-medicale.js?vue&type=script&lang=js&external"
export * from "./historique-imagerie-medicale.js?vue&type=script&lang=js&external"
import style0 from "./historique-imagerie-medicale.scss?vue&type=style&index=0&id=231c866a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c866a",
  null
  
)

export default component.exports